<!-- 由 woniu6162 创建于 2020-12-03 星期四 -->
<template>
  <div class="ponent-box" v-if="list && list.length">
    <template v-for="(item, index) in list">
      <div :key="index" class="pb_wrap">
        <div class="pb_w_title">{{ item.sub_title }}</div>
        <template v-for="(sItem, sIndex) in item.sub_list">
          <div
            v-if="
              sItem.field != 'accompany_phone' &&
              !(
                sItem.field == 'nickname' && $route.query.sfrom == 'campReserve'
              )
            "
            :key="sIndex"
            class="pb_wt_item"
            :id="'pb_wt_item_' + index + '_' + sIndex"
          >
            <template v-if="['string', 'int'].includes(sItem.field_type)">
              <van-field
                v-model="datum[sItem.field]"
                :label="`${sItem.field_title} ${sItem.field_unit}`"
                :type="fType(sItem.field)"
                :maxlength="fLen(sItem.field)"
                label-width="23vw"
                label-align="left"
                @blur="fInput(sItem.field)"
                :disabled="disabledInput(sItem)"
              />
              <div class="pb_wti_sub" v-if="sItem.sub_text">
                {{ sItem.sub_text }}
              </div>
            </template>
            <!-- 省市选择 -->
            <template
              v-else-if="sItem.field_type == 'province' && datum.region == '3'"
            >
              <div class="pb_wti_select" @click="tapAddress(sItem)">
                <div class="pb_wtis_label">{{ sItem.field_title }}</div>
                <div class="pb_wtis_input">
                  {{
                    datum[sItem.field_type] &&
                    datum[sItem.field_type][0].name +
                      ' ' +
                      datum[sItem.field_type][1].name
                  }}
                </div>
                <van-icon name="arrow-down" />
              </div>
              <div class="pb_wti_sub" v-if="sItem.sub_text">
                {{ sItem.sub_text }}
              </div>
            </template>
            <template v-else-if="sItem.field_type == 'select'">
              <div class="pb_wti_select" @click="tapField(sItem)">
                <div class="pb_wtis_label">{{ sItem.field_title }}</div>
                <div class="pb_wtis_input">
                  {{ fResult(sItem) }}
                </div>
                <van-icon
                  name="arrow-down"
                  v-if="
                    !(
                      sItem.field === 'knows_from' &&
                      $route.query.sfrom === 'campReserve'
                    )
                  "
                />
              </div>
              <div class="pb_wti_sub" v-if="sItem.sub_text">
                {{ sItem.sub_text }}
              </div>
            </template>
            <template
              v-else-if="['checkbox', 'radio'].includes(sItem.field_type)"
            >
              <div class="pb_wti_title" v-if="sItem.field_title">
                {{ `· ${sItem.field_title}` }}
              </div>
              <div class="pb_wti_sub" v-if="sItem.sub_text">
                {{ `${sItem.sub_text}` }}
              </div>
              <div class="pb_wti_box">
                <template v-if="sItem.field_type == 'checkbox'">
                  <template v-for="(gItem, gIndex) in sItem.field_unit">
                    <van-checkbox
                      :key="gIndex"
                      :value="sItem.field_unit[gIndex].isCheck"
                      @click="bindCheckboxChange(sItem, gIndex)"
                      shape="square"
                      :name="gItem.key"
                      checked-color="#ff5a5a"
                      icon-size="5.3vw"
                      >{{ gItem.value }}</van-checkbox
                    >
                  </template>
                  <div class="other-box" v-if="sItem.haveOther">
                    <input
                      type="text"
                      v-model="sItem.extra"
                      placeholder="其他"
                      class="other-input"
                      maxlength="50"
                    />
                  </div>
                </template>
                <template v-if="sItem.field_type == 'radio'">
                  <van-radio-group v-model="datum[sItem.field]">
                    <template v-for="(gItem, gIndex) in sItem.field_unit">
                      <van-radio
                        :key="gIndex"
                        shape="round"
                        :name="gItem.key"
                        checked-color="#ff5a5a"
                        icon-size="5.3vw"
                        >{{ gItem.value }}</van-radio
                      >
                    </template>
                  </van-radio-group>
                </template>
              </div>
            </template>
          </div>
        </template>
      </div>
    </template>
    <slot name="submit">
      <div class="bottom">
        <div class="agreement">
          <div class="check" @click="bindToggleAgreement">
            <span class="iconfont icon-gou" v-show="consentAgreement"></span>
          </div>
          <div>
            我已详细阅读并同意<span class="text" @click="bindToAgreement"
              >《健萌用户服务/隐私协议》</span
            >
          </div>
        </div>
        <div class="pb_submit" @click="submit">提交</div>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  name: 'p-box',
  mixins: [],
  components: {},
  props: { list: {}, datum: {} },

  data() {
    return {
      consentAgreement: false
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    disabledInput(sItem) {
      return (
        (this.$route.query.phone && sItem.field == 'phone') ||
        sItem.field == 'unify_id'
      )
    },
    bindToggleAgreement() {
      this.consentAgreement = !this.consentAgreement
    },
    bindToAgreement() {
      this.$router.push('/join-camp-question-agreement')
    },
    tapField(item) {
      // app中预约过来的 购买途径 锁死
      if (
        item.field === 'knows_from' &&
        this.$route.query.sfrom === 'campReserve'
      ) {
        return
      }
      this.$emit('tapField', item)
    },
    tapAddress(item) {
      this.$emit('tapAddress', item)
    },
    // 提交
    submit() {
      if (!this.consentAgreement) {
        this.$toast('您还未同意用户协议')
        return
      }
      this.$emit('submit')
    },
    bindCheckboxChange(items, index) {
      let field = items.field_unit
      let key = items.field
      // 如果点击的是互斥项
      if (field[index].none) {
        field.map((item, index1) => {
          if (item.isCheck && index !== index1) {
            item.isCheck = false
          }
        })
        field[index].isCheck = !field[index].isCheck
        field.map((item) => {
          if (!field[index].extra && item.extra) {
            items.haveOther = false
          }
        })
      } else {
        // 选择的不是互斥项则删除选中的互斥项
        field.map((item) => {
          if (item.none) {
            item.isCheck = false
          }
        })
        field[index].isCheck = !field[index].isCheck
      }
      if (field[index].extra) {
        items.haveOther = field[index].isCheck
      }
      let arr = []
      for (let i = 0; i < field.length; i++) {
        if (field[i].isCheck) {
          arr.push(field[i].key)
        }
      }
      this.datum[key] = arr
      console.log(this.datum[key])
    },
    // 格式化结果项
    fResult(obj) {
      if (obj.field === 'city' && this.datum[obj.field]) {
        let ss = ''
        this.datum[obj.field].forEach((item) => {
          ss += `${item.name} `
        })
        return ss
      }
      let str = ''
      obj.field_unit.filter((item) => {
        if (this.datum[obj.field] === item.key) {
          str = item.value
        }
      })
      return str
    },
    fAddress(obj) {
      let str = ''
      if (Array.isArray(obj)) {
        str = (obj[0].name || '') + (obj[1].name || '')
      }
      return str
    },
    // 过滤输入
    fInput(id) {
      // 订单编号 过滤掉中文
      if (id === 'order_no') {
        this.datum[id] = this.datum[id].replace(
          /[\u3400-\u4DB5\u4E00-\u9FEA\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\u{20000}-\u{2A6D6}\u{2A700}-\u{2B734}\u{2B740}-\u{2B81D}\u{2B820}-\u{2CEA1}\u{2CEB0}-\u{2EBE0}]/gu,
          ''
        )
      }
    },
    // 格式化field类型
    fType(val) {
      let str = 'text'
      let arr = ['age', 'phone', 'height', 'weight']
      if (arr.includes(val)) str = 'digit'
      return str
    },
    // 格式化field字符长度
    fLen(val) {
      let num = null
      switch (val) {
        case 'age':
          num = 2
          break
        case 'phone':
          num = 11
          break
        case 'height':
        case 'weight':
          num = 3
          break
        case 'order_no':
          num = 99
          break
        default:
          break
      }
      return num
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom {
  padding: 17px 10px 36px;

  .agreement {
    margin-bottom: 17px;
    text-align: center;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #888888;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    .check {
      width: 16px;
      height: 16px;
      background: #ff2b48;
      border-radius: 4px;
      margin-right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        color: #fff;
        font-size: 8px;
      }
    }

    .text {
      color: rgba(0, 0, 0, 0.8);
    }
  }
}

.ponent-box {
  padding: 0 5.3vw;
  box-sizing: border-box;

  .pb_wrap + .pb_wrap {
    margin-top: 5.3vw;
  }

  .pb_wrap {
    // margin-top: 5.3vw;
    .pb_w_title {
      font-size: 4.8vw;
      font-weight: 600;
      line-height: 6.4vw;
      color: #000;
      text-align: left;
    }

    .pb_wt_item {
      margin-top: 5.3vw;
      text-align: left;

      .pb_wti_select {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 1.6vw;
        border: solid 0.3vw #f1f1f1;
        background: #fff;
        padding: 3vw 5.1vw;
        font-size: 3.5vw;
        line-height: 24px;
        text-align: left;

        .pb_wtis_label {
          min-width: 23vw;
          color: rgba(0, 0, 0, 0.5);
          margin-right: 12px;
        }

        .pb_wtis_input {
          width: 100%;
          font-weight: 600;
        }
      }

      .van-cell {
        border-radius: 1.6vw;
        border: solid 0.3vw #f1f1f1;
        padding: 3vw 5.1vw;
        font-size: 3.5vw;

        .van-cell__title {
          text-align: left;
          color: rgba(0, 0, 0, 0.5);
        }

        .van-cell__value {
          font-weight: 600;
        }
      }

      .pb_wti_title {
        margin-left: -0.5em;
        font-size: 3.7vw;
        font-weight: 600;
        color: #000;
      }

      .pb_wti_sub {
        margin-top: 1.9vw;
        font-size: 3.2vw;
        line-height: 5.9vw;
        color: rgba(0, 0, 0, 0.5);
      }

      .pb_wti_box {
        margin-top: 2.7vw;
        padding: 3.7vw 4.3vw;
        background-color: #fff;
        border-radius: 1.6vw;
        border: solid 0.3vw #f1f1f1;

        .van-checkbox + .van-checkbox {
          margin-top: 5.3vw;
        }

        .van-checkbox {
          display: flex;
          align-items: flex-start;
          font-size: 3.5vw;
          color: #000;

          .van-checkbox__icon > i {
            // border-radius: 0.5vw;
            border: 0.3vw solid #f1f1f1;
          }

          .van-checkbox__icon--checked + span {
            color: #ff5a5a;
            font-weight: 600;
          }
        }

        .van-radio + .van-radio {
          margin-top: 5.3vw;
        }

        .van-radio {
          display: flex;
          align-items: flex-start;
          font-size: 3.5vw;
          color: #000;

          .van-radio__icon > i {
            // border-radius: 0.5vw;
            border: 0.3vw solid #f1f1f1;
          }

          .van-radio__icon--checked + span {
            color: #ff5a5a;
            font-weight: 600;
          }
        }
      }
    }
  }

  .pb_submit {
    height: 44px;
    background: #ff2b48;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
  }
}

.other-box {
  margin-top: 4vw;

  .other-input {
    padding: 2.7vw;
    width: 100%;
    height: 10.7vw;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 1.6vw;
    border: solid 0.3vw #f1f1f1;
    font-family: PingFangSC-Medium;
    font-size: 3.5vw;
    color: #000;
    line-height: 4.5vw;
  }
}
</style>
